import React from 'react'

import { ConfirmDialog } from '@mangovoice/mango-ui'

import { useExtensionsI18n } from '../i18n/provider'

export const BulkActiveStateDialog: React.FC<{
  isOpen: boolean
  onClose: () => void
  targetActive: boolean
  onConfirm: () => void
  isPending: boolean
}> = ({ isOpen, onClose, targetActive, onConfirm, isPending }) => {
  const { text } = useExtensionsI18n()
  const action = targetActive
    ? text('extensions.row.activate', 'Activate').toLowerCase()
    : text('extensions.row.deactivate', 'Deactivate').toLowerCase()
  return (
    <ConfirmDialog
      open={isOpen}
      onClose={onClose}
      title={
        targetActive
          ? text(
              'extensions.bulkActiveDialog.activateTitle',
              'Activate all extensions',
            )
          : text(
              'extensions.bulkActiveDialog.deactivateTitle',
              'Deactivate all extensions',
            )
      }
      description={text(
        'extensions.bulkActiveDialog.body',
        'You are about to {{action}} all extensions, which will cause all devices using these extensions as the Primary Line Extension to be rebooted.',
        { action },
      )}
      confirmLabel={
        targetActive
          ? text('extensions.bulkActiveDialog.activateAll', 'Activate All')
          : text('extensions.bulkActiveDialog.deactivateAll', 'Deactivate All')
      }
      cancelLabel={text('extensions.common.cancel', 'Cancel')}
      confirmColorPalette={targetActive ? 'success' : 'warning'}
      isLoading={isPending}
      maxWidth="480px"
      onConfirm={onConfirm}
    >
      {text(
        'extensions.bulkActiveDialog.confirmPrompt',
        'Are you sure you want to continue?',
      )}
    </ConfirmDialog>
  )
}
